<template>
    <div style="color:var(--navBackgroundColor)">

        <span class="item">
            ©2021 Learn and Watch -  Tous droits réservés |
        </span>

        <span class="item clickable">
            <a href="https://www.facebook.com/Learn-and-Watch-103125158025351/" style="text-decoration: none; color: var(--navBackgroundColor); " target="_blank"><i class="fab fa-facebook-square"></i></a>
        </span>

        <span class="item clickable">
            <a href="https://twitter.com/Learn_and_Watch" style="text-decoration: none; color: var(--navBackgroundColor); " target="_blank"><i class="fab fa-twitter"></i></a>
        </span>

        <span class="item clickable">
            <a href="http://instagram.com/learnandwatch_com/" style="text-decoration: none; color: var(--navBackgroundColor)" target="_blank"><i class="fab fa-instagram"></i></a>
        </span>

      |
      <span class="item clickable">
            <a href="https://www.learnandwatch.com/blog" style="text-decoration: none; color: var(--navBackgroundColor);" >Blog</a>

        </span>
      |
      <span class="item clickable">
            <a href="mailto:contact@learnandwatch.com" style="text-decoration: none; color: var(--navBackgroundColor)" target="_blank">Contact</a>

        </span>
      |
      <span class="item clickable">
          <router-link :to="{name: 'about'}" style="text-decoration: none; color: var(--navBackgroundColor)">À propos</router-link>
        </span>
      |
      <span class="item clickable">
          <router-link :to="{name: 'cgu'}" style="text-decoration: none; color: var(--navBackgroundColor)">CGU</router-link>
        </span>
    </div>

</template>

<script>
	import {mapGetters} from "vuex";

  export default {
		name: "vuefooter",
        methods: {

        },

    computed: {
      ...mapGetters('global', [
        'isMobile',
      ]),
    },

        data() {
			return {
				contact: "contact",
                about: "about",
                screenWidth: window.screen.width,
            }
        }
	}
</script>

<style scoped>

    .item {
        margin: 8px;
    }

    .clickable{
        cursor: pointer;
    }

</style>
